import React from "react";
import { ClipLoader } from "react-spinners";
import { shadeColor } from "../../utils/General";

const Div = ({ children, ...rest }) => (
  <div {...rest}>
    <span>{children}</span>
  </div>
);
const Button = ({
  as = "div",
  justLoading = false,
  noOpacityOnDisable = false,
  contentClassName = "",
  onClick = () => {},
  variant = "filledPrimary",
  progress = 0,
  small = false,
  disabled = false,
  loading = false,
  children,
  className = "",
  rightIcon = null,
  leftIcon = null,
  darkStyle = false,
  ...rest
}) => {
  const _class = [];
  const variantColors = {
    filledPrimary: "#1E208D",
    hidden: "#ffffff",
    cancel: "#c8cbda",
    error: "#FF5E56",
    attention: "#F5901E",
  };
  const variantStyles = {
    filledPrimary: "bg-accent dark:bg-accent-dark dark:text-title text-white",
    hidden: "bg-transparent text-brand",
    cancel: "bg-accent-negative dark:bg-actions-dark text-title",
    error: "bg-error dark:text-title text-white",
    attention: "bg-attention text-white",
  };

  const darkVariantStyles = {
    filledPrimary: "bg-[#1E208D] text-[#fff]",
    hidden: "bg-transparent text-brand",
    cancel: "bg-actions-dark text-title",
    error: "bg-error text-title",
    attention: "bg-attention text-white",
  };

  const loadingColors = {
    filledPrimary: "#ffffff",
    hidden: "#1E208D",
    cancel: "#1E208D",
    error: "#ffffff",
    attention: "#ffffff",
  };
  if (disabled || loading) {
    if (!noOpacityOnDisable) _class.push("opacity-90");
    _class.push("pointer-events-none");
  }

  if (loading || disabled) _class.push("cursor-default");
  if (!loading && !disabled) _class.push("cursor-pointer");

  if (small) _class.push("h-10 text-sm rounded-xl");
  else _class.push("h-12 text-sm rounded-2xl");

  if (darkStyle) {
    _class.push(darkVariantStyles[variant]);
  } else {
    _class.push(variantStyles[variant]);
  }
  const WrapperComponent = as === "div" ? Div : as;

  return (
    <WrapperComponent
      style={{
        ...(disabled || loading
          ? { filter: "grayscale(1)", pointerEvents: "none" }
          : {}),
      }}
      className={`select-none  ${className}`}
      onClick={disabled || loading ? undefined : onClick}
      {...rest}
    >
      <div
        className={`active:opacity-70 px-2 transition-all overflow-hidden font-bold w-full flex justify-center items-center relative ${_class.join(
          " "
        )}`}
      >
        {progress > 0 && (
          <div
            className={`h-full opacity-70 absolute left-0 transition-all`}
            style={{
              width: `${progress}%`,
              backgroundColor: shadeColor(variantColors[variant], 60),
            }}
          />
        )}
        <div
          className={`relative z-10 flex flex-row justify-center items-center ${contentClassName}`}
        >
          {loading === true && (
            <div style={{ height: 18 }} className="mx-2">
              <ClipLoader size={18} color={loadingColors[variant]} />
            </div>
          )}
          {loading ? null : rightIcon}
          {justLoading === true && loading === true ? (
            <span />
          ) : (
            <span>{children}</span>
          )}
          {loading ? null : leftIcon}
        </div>
      </div>
    </WrapperComponent>
  );
};

export default Button;
